import React, { useState, useEffect, useContext } from 'react';
import FileBUUploadModalTrkNew from './FileBUUploadModalTrkNew';
import { deleteFromCache, saveToCache, loadTitleCache, loadFromCacheBu } from './CacheHandler';
import { FaRegFilePdf, FaFilePowerpoint, FaRegFileExcel, FaFileWord, FaFile, FaFolderOpen } from 'react-icons/fa';
import { ModeContext } from './ModeContext';
import ListItemButton from '@mui/material/ListItemButton';
import {
  Box,
  Typography,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Collapse,
  Divider
} from '@mui/material';　
import { ExpandLess, ExpandMore, ControlPoint } from '@mui/icons-material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { LoadToCosmos } from './SendToCosmos';

const SettingsDocUpTrkNew = () => {
  const [loading, setLoading] = useState(true);
  const [openItems, setOpenItems] = useState({});
  const [openCategories, setOpenCategories] = useState({});
  const [isNewModalOpen, setIsNewModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const { filebuList, setFilebuList } = useContext(ModeContext);

  //画面更新用
  const handleUpdateComplete = () => {
    fetchFileListbu();
  };

  // 事業部ごと・カテゴリごとにデータを整理
  const fetchFileListbu = async () => {
    try {
      const uppayload = { id: 'all', container: 'con-concierge-filebutrknew' };
      const items = await LoadToCosmos(uppayload);
      const grouped = {};

      items.item.forEach((bu) => {
        const buId = bu.id;
        grouped[buId] = {};
        //saveToCache(buId,'chat-bufilenew-cache','' ,bu.messages,'','',''); 
        // bu.messages は「配列」
        if (Array.isArray(bu.messages)) {
          bu.messages.forEach((cat) => {
            const catName = cat.category || '未分類';
            
            grouped[buId][catName] = cat.messages || [];
          });
        }
      });

//      await saveToCache(fileData.buId,'chat-bufilenew-cache',file.name ,uppayload,timestamp,'',''); 

      setFilebuList(grouped);
    } catch (error) {
      console.error('データ取得エラー:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFileListbu();
  }, []);

  const handleToggle = (id) => {
    setOpenItems((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleCategory = (categoryKey) => {
    setOpenCategories((prev) => ({ ...prev, [categoryKey]: !prev[categoryKey] }));
  };

  const handleOpenModal = (buId) => {
    setSelectedFile({ buId });
    setIsNewModalOpen(true);
  };

  const handleFileClick = (message, buId) => {
    setSelectedFile({ ...message, buId });
    setIsNewModalOpen(true);
  };

  const getFileIcon = (filename) => {
    if (!filename) return <FaFile style={{ marginRight: 8 }} />;
    if (filename.endsWith('.pdf')) return <FaRegFilePdf style={{ marginRight: 8, color: '#D24726' }} />;
    if (filename.endsWith('.xls') || filename.endsWith('.xlsx')) return <FaRegFileExcel style={{ marginRight: 8, color: 'green' }} />;
    if (filename.endsWith('.doc') || filename.endsWith('.docx')) return <FaFileWord style={{ marginRight: 8, color: 'blue' }} />;
    if (filename.endsWith('.ppt') || filename.endsWith('.pptx')) return <FaFilePowerpoint style={{ marginRight: 8, color: '#D24726' }} />;
    return <FaFile style={{ marginRight: 8 }} />;
  };
return (
<Box sx={{ height: '80vh', overflow: 'auto', p: 2 }}>
  <Typography variant="h5" component="div" sx={{ color: '#1976d2', mb: 2 }}>
    <FileUploadIcon /> Newサービスマニュアル_取込み
  </Typography>

  {loading ? (
    <CircularProgress />
  ) : (
    <List sx={{ width: "100%" }} dense>
      <Divider />

      {Object.entries(filebuList || {}).map(([buId, categories], index) => (
        <React.Fragment key={buId}>
          {index !== 0 && <Divider />}

          {/* BU 行（コンパクト） */}
          <ListItem dense sx={{ py: 0.4, minHeight: "34px" }}>
            <ListItemButton
              onClick={() => handleToggle(buId)}
              sx={{ py: 0.3, minHeight: "32px" }}
            >
              <ListItemText
                primary={buId}
                primaryTypographyProps={{ fontSize: 13 }}
              />

              <IconButton
                edge="end"
                sx={{ mr: 2, p: 0.5 }}
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenModal(buId);
                }}
              >
                <ControlPoint fontSize="small" />
              </IconButton>

              {openItems[buId] ? (
                <ExpandLess fontSize="small" />
              ) : (
                <ExpandMore fontSize="small" />
              )}
            </ListItemButton>
          </ListItem>

          <Divider sx={{ ml: 2 }} />

          {/* Category List */}
          <Collapse in={openItems[buId]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding dense>

              {Object.entries(categories).map(([category, messages]) => (
                <React.Fragment key={category}>

                  {/* Category 行（さらにコンパクト） */}
                  <ListItem
                    button
                    dense
                    sx={{ pl: 4, py: 0.4, minHeight: "30px" }}
                    onClick={() => toggleCategory(`${buId}-${category}`)}
                  >
                    <FaFolderOpen
                      style={{
                        marginRight: 8,
                        color: '#FFCC00',
                        fontSize: '16px'
                      }}
                    />
                    <ListItemText
                      primary={category || '未分類'}
                      primaryTypographyProps={{ fontSize: 13 }}
                    />

                    {openCategories[`${buId}-${category}`] ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </ListItem>

                  <Divider sx={{ ml: 4 }} />

                  {/* File List */}
                  <Collapse
                    in={openCategories[`${buId}-${category}`]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding dense>

                      {messages.map((message) => (
                        <React.Fragment key={message.id}>
                          {/* ファイル行（最もコンパクト） */}
                          <ListItem
                            button
                            dense
                            sx={{ pl: 6, py: 0.3, minHeight: "26px" }}
                            onClick={() => handleFileClick(message, buId)}
                          >
                            {getFileIcon(message.filename)}
                            <ListItemText
                              primary={message.filename}
                              primaryTypographyProps={{ fontSize: 12 }}
                            />
                          </ListItem>

                          <Divider sx={{ ml: 6 }} />
                        </React.Fragment>
                      ))}

                    </List>
                  </Collapse>

                </React.Fragment>
              ))}

            </List>
          </Collapse>

        </React.Fragment>
      ))}
    </List>
  )}

  <FileBUUploadModalTrkNew
    open={isNewModalOpen}
    onClose={() => setIsNewModalOpen(false)}
    fileData={selectedFile || {}}
    filebuList={filebuList}
    type="cust"
    onUpdated={handleUpdateComplete}
  />
</Box>
);
};

export default SettingsDocUpTrkNew;
